module.exports = __webpack_public_path__ + "img/con4-info.c4926cd3.png";